export const toAbsoluteUrl = (pathname: string) =>
  new URL(pathname, window.location.origin).href;
